export const days = {
    monday: "월요일",
    tuesday: "화요일",
    wednesday: "수요일",
    thursday: "목요일",
    friday: "금요일",
    saturday: "토요일",
    sunday: "일요일",
    mondayShort: "월",
    tuesdayShort: "화",
    wednesdayShort: "수",
    thursdayShort: "목",
    fridayShort: "금",
    saturdayShort: "토",
    sundayShort: "일",
}
